import { useState } from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { ErrorAlert } from '@/components/error-alert';
import { api } from '@/lib/api';
import { getErrorMessage } from '@/lib/error-message';

export function DeleteOrganizationModal({
  organizationId,
  organizationName,
  onClose,
  onDeleted,
}: {
  organizationId: string;
  organizationName: string;
  onClose: () => void;
  onDeleted: () => void;
}) {
  const [error, setError] = useState<string | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const remove = async () => {
    setError(null);
    setIsDeleting(true);

    const { error: apiError } = await api.organizations({ organizationId }).delete();

    setIsDeleting(false);

    if (apiError) {
      setError(getErrorMessage(apiError, 'Failed to delete organization'));

      return;
    }

    onDeleted();
  };

  return (
    <Modal opened onClose={onClose} title="Delete Organization">
      <Stack gap="md">
        <Text>
          Are you sure you want to delete <strong>{organizationName}</strong>? This will remove all members and cannot
          be undone.
        </Text>
        <Text size="sm" c="dimmed">
          Organizations with phone numbers or flows cannot be deleted.
        </Text>
        <ErrorAlert message={error} />
        <Group justify="flex-end" mt="xs">
          <Button variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" onClick={() => void remove()} loading={isDeleting}>
            Delete Organization
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
